import * as tokens from '../../../../../tokens/color.light.generated.js';
export const semanticColorLight = {
    color: {
        action: {
            primary: {
                surface: {
                    fill: {
                        default: tokens.SEM_COLOR_ACTION_PRIMARY_SURFACE_FILL_DEFAULT_LIGHT,
                        hover: tokens.SEM_COLOR_ACTION_PRIMARY_SURFACE_FILL_HOVER_LIGHT,
                        pressed: tokens.SEM_COLOR_ACTION_PRIMARY_SURFACE_FILL_PRESSED_LIGHT,
                        disabled: tokens.SEM_COLOR_ACTION_PRIMARY_SURFACE_FILL_DISABLED_LIGHT
                    },
                    stroke: {
                        default: tokens.SEM_COLOR_ACTION_PRIMARY_SURFACE_STROKE_DEFAULT_LIGHT,
                        hover: tokens.SEM_COLOR_ACTION_PRIMARY_SURFACE_STROKE_HOVER_LIGHT,
                        pressed: tokens.SEM_COLOR_ACTION_PRIMARY_SURFACE_STROKE_PRESSED_LIGHT,
                        disabled: tokens.SEM_COLOR_ACTION_PRIMARY_SURFACE_STROKE_DISABLED_LIGHT
                    }
                },
                foreground: {
                    icon: {
                        default: tokens.SEM_COLOR_ACTION_PRIMARY_FOREGROUND_ICON_DEFAULT_LIGHT,
                        hover: tokens.SEM_COLOR_ACTION_PRIMARY_FOREGROUND_ICON_HOVER_LIGHT,
                        pressed: tokens.SEM_COLOR_ACTION_PRIMARY_FOREGROUND_ICON_PRESSED_LIGHT,
                        disabled: tokens.SEM_COLOR_ACTION_PRIMARY_FOREGROUND_ICON_DISABLED_LIGHT
                    },
                    text: {
                        default: tokens.SEM_COLOR_ACTION_PRIMARY_FOREGROUND_TEXT_DEFAULT_LIGHT,
                        hover: tokens.SEM_COLOR_ACTION_PRIMARY_FOREGROUND_TEXT_HOVER_LIGHT,
                        pressed: tokens.SEM_COLOR_ACTION_PRIMARY_FOREGROUND_TEXT_PRESSED_LIGHT,
                        disabled: tokens.SEM_COLOR_ACTION_PRIMARY_FOREGROUND_TEXT_DISABLED_LIGHT
                    }
                }
            },
            secondary: {
                surface: {
                    fill: {
                        default: tokens.SEM_COLOR_ACTION_SECONDARY_SURFACE_FILL_DEFAULT_LIGHT,
                        hover: tokens.SEM_COLOR_ACTION_SECONDARY_SURFACE_FILL_HOVER_LIGHT,
                        pressed: tokens.SEM_COLOR_ACTION_SECONDARY_SURFACE_FILL_PRESSED_LIGHT,
                        disabled: tokens.SEM_COLOR_ACTION_SECONDARY_SURFACE_FILL_DISABLED_LIGHT
                    },
                    stroke: {
                        default: tokens.SEM_COLOR_ACTION_SECONDARY_SURFACE_STROKE_DEFAULT_LIGHT,
                        hover: tokens.SEM_COLOR_ACTION_SECONDARY_SURFACE_STROKE_HOVER_LIGHT,
                        disabled: tokens.SEM_COLOR_ACTION_SECONDARY_SURFACE_STROKE_DISABLED_LIGHT,
                        pressed: tokens.SEM_COLOR_ACTION_SECONDARY_SURFACE_STROKE_PRESSED_LIGHT
                    }
                },
                foreground: {
                    icon: {
                        default: tokens.SEM_COLOR_ACTION_SECONDARY_FOREGROUND_ICON_DEFAULT_LIGHT,
                        hover: tokens.SEM_COLOR_ACTION_SECONDARY_FOREGROUND_ICON_HOVER_LIGHT,
                        pressed: tokens.SEM_COLOR_ACTION_SECONDARY_FOREGROUND_ICON_PRESSED_LIGHT,
                        disabled: tokens.SEM_COLOR_ACTION_SECONDARY_FOREGROUND_ICON_DISABLED_LIGHT
                    },
                    text: {
                        default: tokens.SEM_COLOR_ACTION_SECONDARY_FOREGROUND_TEXT_DEFAULT_LIGHT,
                        hover: tokens.SEM_COLOR_ACTION_SECONDARY_FOREGROUND_TEXT_HOVER_LIGHT,
                        pressed: tokens.SEM_COLOR_ACTION_SECONDARY_FOREGROUND_TEXT_PRESSED_LIGHT,
                        disabled: tokens.SEM_COLOR_ACTION_SECONDARY_FOREGROUND_TEXT_DISABLED_LIGHT
                    }
                }
            },
            tertiary: {
                surface: {
                    fill: {
                        default: tokens.SEM_COLOR_ACTION_TERTIARY_SURFACE_FILL_DEFAULT_LIGHT,
                        hover: tokens.SEM_COLOR_ACTION_TERTIARY_SURFACE_FILL_HOVER_LIGHT,
                        pressed: tokens.SEM_COLOR_ACTION_TERTIARY_SURFACE_FILL_PRESSED_LIGHT,
                        disabled: tokens.SEM_COLOR_ACTION_TERTIARY_SURFACE_FILL_DISABLED_LIGHT
                    },
                    stroke: {
                        default: tokens.SEM_COLOR_ACTION_TERTIARY_SURFACE_STROKE_DEFAULT_LIGHT,
                        hover: tokens.SEM_COLOR_ACTION_TERTIARY_SURFACE_STROKE_HOVER_LIGHT,
                        pressed: tokens.SEM_COLOR_ACTION_TERTIARY_SURFACE_STROKE_PRESSED_LIGHT,
                        disabled: tokens.SEM_COLOR_ACTION_TERTIARY_SURFACE_STROKE_DISABLED_LIGHT
                    }
                },
                foreground: {
                    icon: {
                        default: tokens.SEM_COLOR_ACTION_TERTIARY_FOREGROUND_ICON_DEFAULT_LIGHT,
                        hover: tokens.SEM_COLOR_ACTION_TERTIARY_FOREGROUND_ICON_HOVER_LIGHT,
                        pressed: tokens.SEM_COLOR_ACTION_TERTIARY_FOREGROUND_ICON_PRESSED_LIGHT,
                        disabled: tokens.SEM_COLOR_ACTION_TERTIARY_FOREGROUND_ICON_DISABLED_LIGHT
                    },
                    text: {
                        default: tokens.SEM_COLOR_ACTION_TERTIARY_FOREGROUND_TEXT_DEFAULT_LIGHT,
                        hover: tokens.SEM_COLOR_ACTION_TERTIARY_FOREGROUND_TEXT_HOVER_LIGHT,
                        pressed: tokens.SEM_COLOR_ACTION_TERTIARY_FOREGROUND_TEXT_PRESSED_LIGHT,
                        disabled: tokens.SEM_COLOR_ACTION_TERTIARY_FOREGROUND_TEXT_DISABLED_LIGHT
                    }
                }
            }
        },
        forms: {
            foreground: {
                icons: {
                    default: tokens.SEM_COLOR_FORMS_FOREGROUND_ICONS_DEFAULT_LIGHT,
                    disabled: tokens.SEM_COLOR_FORMS_FOREGROUND_ICONS_DISABLED_LIGHT,
                    error: tokens.SEM_COLOR_FORMS_FOREGROUND_ICONS_ERROR_LIGHT,
                    interactive: tokens.SEM_COLOR_FORMS_FOREGROUND_ICONS_INTERACTIVE_LIGHT
                },
                text: {
                    error: tokens.SEM_COLOR_FORMS_FOREGROUND_TEXT_ERROR_LIGHT,
                    default: tokens.SEM_COLOR_FORMS_FOREGROUND_TEXT_DEFAULT_LIGHT,
                    interactive: tokens.SEM_COLOR_FORMS_FOREGROUND_TEXT_INTERACTIVE_LIGHT,
                    caption: tokens.SEM_COLOR_FORMS_FOREGROUND_TEXT_CAPTION_LIGHT,
                    disabled: tokens.SEM_COLOR_FORMS_FOREGROUND_TEXT_DISABLED_LIGHT
                },
                divider: {
                    default: tokens.SEM_COLOR_FORMS_FOREGROUND_DIVIDER_DEFAULT_LIGHT
                }
            },
            surface: {
                control: {
                    stroke: {
                        error: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_STROKE_ERROR_LIGHT,
                        readOnly: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_STROKE_READ_ONLY_LIGHT,
                        disabled: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_STROKE_DISABLED_LIGHT,
                        default: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_STROKE_DEFAULT_LIGHT,
                        interactive: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_STROKE_INTERACTIVE_LIGHT
                    },
                    indicator: {
                        default: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_INDICATOR_DEFAULT_LIGHT,
                        interactive: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_INDICATOR_INTERACTIVE_LIGHT,
                        readOnly: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_INDICATOR_READ_ONLY_LIGHT,
                        disabled: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_INDICATOR_DISABLED_LIGHT,
                        error: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_INDICATOR_ERROR_LIGHT
                    },
                    fill: {
                        readOnly: tokens.SEM_COLOR_FORMS_SURFACE_CONTROL_FILL_READ_ONLY_LIGHT
                    }
                },
                underline: {
                    stroke: {
                        error: tokens.SEM_COLOR_FORMS_SURFACE_UNDERLINE_STROKE_ERROR_LIGHT,
                        default: tokens.SEM_COLOR_FORMS_SURFACE_UNDERLINE_STROKE_DEFAULT_LIGHT,
                        interactive: tokens.SEM_COLOR_FORMS_SURFACE_UNDERLINE_STROKE_INTERACTIVE_LIGHT,
                        disabled: tokens.SEM_COLOR_FORMS_SURFACE_UNDERLINE_STROKE_DISABLED_LIGHT
                    }
                }
            }
        },
        navigation: {
            foreground: {
                indicator: {
                    active: tokens.SEM_COLOR_NAVIGATION_FOREGROUND_INDICATOR_ACTIVE_LIGHT,
                    inactive: tokens.SEM_COLOR_NAVIGATION_FOREGROUND_INDICATOR_INACTIVE_LIGHT
                },
                icon: {
                    interactive: tokens.SEM_COLOR_NAVIGATION_FOREGROUND_ICON_INTERACTIVE_LIGHT,
                    disabled: tokens.SEM_COLOR_NAVIGATION_FOREGROUND_ICON_DISABLED_LIGHT
                },
                text: {
                    active: tokens.SEM_COLOR_NAVIGATION_FOREGROUND_TEXT_ACTIVE_LIGHT,
                    interactive: tokens.SEM_COLOR_NAVIGATION_FOREGROUND_TEXT_INTERACTIVE_LIGHT,
                    idle: tokens.SEM_COLOR_NAVIGATION_FOREGROUND_TEXT_IDLE_LIGHT,
                    disabled: tokens.SEM_COLOR_NAVIGATION_FOREGROUND_TEXT_DISABLED_LIGHT
                }
            },
            surface: {
                fill: {
                    pressed: tokens.SEM_COLOR_NAVIGATION_SURFACE_FILL_PRESSED_LIGHT
                }
            }
        },
        feedback: {
            foreground: {
                text: {
                    default: tokens.SEM_COLOR_FEEDBACK_FOREGROUND_TEXT_DEFAULT_LIGHT,
                    inverted: tokens.SEM_COLOR_FEEDBACK_FOREGROUND_TEXT_INVERTED_LIGHT,
                    informative: tokens.SEM_COLOR_FEEDBACK_FOREGROUND_TEXT_INFORMATIVE_LIGHT
                }
            },
            surface: {
                informative: tokens.SEM_COLOR_FEEDBACK_SURFACE_INFORMATIVE_LIGHT,
                success: tokens.SEM_COLOR_FEEDBACK_SURFACE_SUCCESS_LIGHT,
                notice: tokens.SEM_COLOR_FEEDBACK_SURFACE_NOTICE_LIGHT,
                error: tokens.SEM_COLOR_FEEDBACK_SURFACE_ERROR_LIGHT
            }
        },
        ui: {
            surface: {
                scrim: { default: tokens.SEM_COLOR_UI_SURFACE_SCRIM_DEFAULT_LIGHT }
            },
            foreground: {
                divider: {
                    default: tokens.SEM_COLOR_UI_FOREGROUND_DIVIDER_DEFAULT_LIGHT
                },
                icons: {
                    default: tokens.SEM_COLOR_UI_FOREGROUND_ICONS_DEFAULT_LIGHT,
                    interactive: tokens.SEM_COLOR_UI_FOREGROUND_ICONS_INTERACTIVE_LIGHT,
                    disabled: tokens.SEM_COLOR_UI_FOREGROUND_ICONS_DISABLED_LIGHT
                },
                text: {
                    default: tokens.SEM_COLOR_UI_FOREGROUND_TEXT_DEFAULT_LIGHT,
                    interactive: tokens.SEM_COLOR_UI_FOREGROUND_TEXT_INTERACTIVE_LIGHT,
                    disabled: tokens.SEM_COLOR_UI_FOREGROUND_TEXT_DISABLED_LIGHT
                }
            }
        }
    }
};
//# sourceMappingURL=color.light.js.map